import React from "react";
import { Box, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

export interface AuthCardHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Use when the title should not be the document h1 (e.g. nested in a larger page). */
  titleComponent?: React.ElementType;
  titleSx?: SxProps<Theme>;
}

const AuthCardHeader: React.FC<AuthCardHeaderProps> = ({
  title,
  subtitle,
  titleComponent = "h1",
  titleSx,
}) => {
  return (
    <Box sx={{ textAlign: "center", mb: 4 }}>
      <Typography
        variant="h4"
        component={titleComponent}
        gutterBottom
        sx={[{ color: "text.primary" }, ...(Array.isArray(titleSx) ? titleSx : [titleSx])]}
      >
        {title}
      </Typography>
      {subtitle != null && subtitle !== false && (
        <Typography variant="body2" color="text.secondary" component="div">
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default AuthCardHeader;
